import React, {Component} from "react";
import SplashScreen from "../splash-screen";
import Input from "../components/input";
import {
  getUserInfo,
  hasAuth,
  redeemCode,
  getGiftCode,
  fetchPlanData,
} from "../services/api";
import {getPlanInfo} from "../plans";

export default class ClaimPromotions extends Component {
  constructor(props, ctx) {
    super(props, ctx);
    this.loading = this.loading.bind(this);
    this.promocodeOnChange = this.promocodeOnChange.bind(this);
    this.loadPromoInformation = this.loadPromoInformation.bind(this);
    this.renderInitial = this.renderInitial.bind(this);
    this.renderConfirmation = this.renderConfirmation.bind(this);
    this.backToInitial = this.backToInitial.bind(this);
    this.initiateRedemption = this.initiateRedemption.bind(this);

    const step = 'initial';
    const userInfo = getUserInfo();
    const params = new URLSearchParams(this.props.location.search);
    const queryCode = params.get("code");

    this.state = {
      promocode: '' || queryCode,
      loading: false,
      step,
      promoCodeInfo: {},
      planData: {},
      userInfo,
      error: '',
    };

    this.planNames = {
      "NYA-UNLIMITED-MONTHLY" : "NYA CLASSIC",
      "NYA-UNLIMITED-YEARLY" : "NYA CLASSIC",
      "NYA-UNLIMITEDV2-MONTHLY" : "NYA CLASSIC",
      "NYA-UNLIMITEDV2-YEARLY" : "NYA CLASSIC",
      "NYA-UNLIMITED-YEARLY-RUST" : "NYA RUST",
      "NYA-UNLIMITEDV2-YEARLY-RUST" : "NYA RUST",
      "NYA-UNLIMITED-YEARLY-PATRON" : "NYA PATRON",
    };

    if (queryCode) {
      this.loadPromoInformation();
    }
  }

  backToInitial() {
    this.setState({...this.state, step:'initial'});
  }

  promocodeOnChange(value) {
    this.setState({...this.state, promocode: value, error: ''});
  }

  async loadPromoInformation() {
    const promocode = this.state.promocode || '';
    const _hasAuth = hasAuth();
    if (!_hasAuth) {
      window.displayWarningMessage('sign-in');
      return;
    }
    if (promocode === '')
      return;

    this.setState({...this.state, loading: true, error: ''});
    
    try {
      // Use the same API as gift codes
      const promoCodeInfo = await getGiftCode(promocode);
      const planData = await fetchPlanData();
      
      this.setState({
        ...this.state, 
        promoCodeInfo,
        planData, 
        step: 'confirmation',
        loading: false
      });
    } catch (err) {
      this.setState({...this.state, error: 'Promotion code is invalid or has already been claimed!', loading: false});
    }
  }

  async initiateRedemption() {
    this.setState({...this.state, loading: true, error: ''});

    // Use the same redemption API as gift codes
    redeemCode(this.state.promocode).then(() => {
      this.setState({
        ...this.state, 
        loading: false, 
        step: 'success'
      });
    }).catch((e) => {
      console.log(e);
      this.setState({...this.state, loading: false, step: 'initial', error: 'Failed to redeem promotion. Please try again.'});
    });
  }

  loading() {
    return (
      <div className="panel claim-panel">
        <div className="content initial spinner">
          <div style={{"marginBottom": "20px"}}>
            Loading...
          </div>
          <SplashScreen loadState={50}/>
        </div>
      </div>
    );
  }

  renderInitial() {
    const {error} = this.state;
    return (
      <div className="claim-panel panel">
        <div className="title">Claim Promotions</div>
        <div className="content">
          <div className="gift-message">
            Claim your promotion to unlock exclusive benefits!
          </div>
          <div className="gift-form">
            <Input
              className="input--promocode input"
              placeholder="Enter Promotion Code"
              limit={30}
              value={this.state.promocode}
              onChange={this.promocodeOnChange}
              name="code"
            />
          </div>
          {error && <div className="error">{error}</div>}

          <div className="description-section">
            <div className="confirmation-buttons">
              <div className="confirm-purchase" onClick={this.loadPromoInformation}>
                CLAIM PROMOTION
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderConfirmation() {
    const { promoCodeInfo, planData } = this.state;

    const planId = promoCodeInfo.planId;
    const planTitle = this.planNames[planId] || 'Promotion';
    
    // Format dates if available
    let startDate = '';
    let endDate = '';
    if (promoCodeInfo.startDate) {
      startDate = new Date(promoCodeInfo.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }
    if (promoCodeInfo.endDate) {
      endDate = new Date(promoCodeInfo.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    }

    return (
      <div className="claim-panel panel">
        <div className="title">Claim Promotion</div>
        <div className="content">
          <div className="gift-message">
            Promotion Details:
            <div className="gift-details">
              <h2>{planTitle}</h2>
              <div className="gift-description-text">
                {startDate && <p>Start Date: {startDate}</p>}
                {endDate && <p>End Date: {endDate}</p>}
                <p>Code: {this.state.promocode}</p>
              </div>
            </div>
          </div>
          <div className="description-section">
            <div className="confirmation-message padding40">
              <h3 className="confirmation-title">What you need to know:</h3>
              <div className="explanation">
                {planTitle && (
                  <p>Your subscription will be upgraded to {planTitle.toUpperCase()}</p>
                )}
              </div>
            </div>
            <div className="confirmation-buttons">
              <div className="confirm-purchase" onClick={this.initiateRedemption}>
                CONFIRM
              </div>
              <div className="back-purchase" onClick={this.backToInitial}>
                BACK
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div className="claim-panel panel">
        <div className="title">Promotion Claimed!</div>
        <div className="content">
          <div className="gift-message">
            <div className="gift-details">
              <h2>Success!</h2>
              <div className="gift-description-text">
                <p>Your promotion has been activated!</p>
              </div>
            </div>
          </div>
          <div className="description-section">
            <div className="confirmation-buttons">
              <div className="confirm-purchase" onClick={() => this.props.history.push('/account?screen=overview')}>
                GO TO ACCOUNT
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {loading, step} = this.state;
    if (loading)
      return this.loading();

    switch (step) {
      case 'initial':
        return this.renderInitial();
      case 'confirmation':
        return this.renderConfirmation();
      case 'success':
        return this.renderSuccess();
      default:
        return this.renderInitial();
    }
  }
}
